import { useEffect, useState } from 'react';
import { formService } from '../form-service';

interface UseFormFieldOptions {
	name: string;
	value?: any;
	required?: boolean;
	validate?: (value: any) => boolean;
	onChange?: (value: any) => void;
}

export function useFormField({ name, value, required, validate, onChange }: UseFormFieldOptions) {
	const [currentValue, setCurrentValue] = useState<any>('');
	const [validationError, setValidationError] = useState(false);

	useEffect(() => {
		const existingValue = formService.getFieldValue(name);
		if (value !== undefined) {
			formService.setFieldValue(name, value);
			setCurrentValue(value);
		} else if (existingValue !== undefined) {
			setCurrentValue(existingValue);
		}
		formService.setFieldRequired(name, required ?? false);
		if (!required) {
			setValidationError(false);
			formService.setFieldError(name, false);
		}
	}, [value, required]);

	useEffect(() => {
		const unsubscribe = formService.subscribeToField(name, {
			onChange: (newValue) => {
				setCurrentValue(newValue ?? '');
				const isEmpty = !newValue || newValue.length === 0;
				let hasError = false;

				if (isEmpty && required) {
					hasError = true;
				} else if (!isEmpty && validate) {
					hasError = !validate(newValue);
				}

				setValidationError(hasError);
				formService.setFieldError(name, hasError);
				if (onChange && newValue) onChange(newValue);
			},
			onError: (hasError) => {
				setValidationError(hasError);
			},
		});

		return unsubscribe;
	}, [name, value, required, validate]);

	return { currentValue, validationError };
}
